export default "__VITE_ASSET__1tyfhCbs__"